import events from '@picsio/events';

import picsioConfig from '../../../../config';

export default function (userId, event, integrations = [], transportType) {
  if (!event) return false;

  const collectionEventTypes = events.getCollectionTypes(picsioConfig.eventsAppName);
  const subscribeAnyway = ['request.created'].includes(event.type);

  if (collectionEventTypes.includes(event.type)) {
    // Collection events carry the decision on the payload (*DisabledFor).
    // The events worker rebuilds pushDisabledFor from notificationCenter before
    // the socket is sent, so this is not the stored socket integration row.
    // The push → notificationCenter remap below is only for global events.
    const transportTypeDisabledFor = event[`${transportType}DisabledFor`] || [];
    if (transportTypeDisabledFor.includes(userId) && event.type && !subscribeAnyway) return true;
  } else if (!subscribeAnyway) {
    const storedType = transportType === 'push' ? 'notificationCenter' : transportType;
    const transportSettings = integrations.find((item) => item.type === storedType);
    if (!transportSettings || !Array.isArray(transportSettings.eventTypes)) return true;
    if (!transportSettings.eventTypes.includes(event.type)) return true;
  }

  return false;
}
